import { useGetHydratedLessonQuery } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/LessonChirpService.hooks';
import { GET_HYDRATED_LESSON_QUERY } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/LessonChirpService.dfc.new';
import { dataFetchingClient } from '../../utils/DataFetchingClient';
import { updateCache as updateCacheChirp } from '../../utils/DataFetchingClientCache.new';
export const updateLessonCacheChirp = lessonData => {
  updateCacheChirp(GET_HYDRATED_LESSON_QUERY, () => ({
    lesson: lessonData
  }), {
    lessonId: lessonData.id
  });
};
export const useFullLessonChirp = ({
  lessonId,
  skip,
  fetchPolicy
}) => {
  const {
    loading: lessonLoading,
    data,
    error: lessonError
  } = useGetHydratedLessonQuery({
    variables: {
      lessonId
    },
    skip: skip || lessonId === null || isNaN(lessonId),
    fetchPolicy
  });
  return {
    lesson: data === null || data === void 0 ? void 0 : data.lesson,
    lessonLoading,
    lessonError
  };
};
export const getFullLesson = variables => dataFetchingClient.queryUnwrapped({
  query: GET_HYDRATED_LESSON_QUERY,
  variables
}).then(response => response.lesson);
export const useLessonContentById = ({
  lessonId,
  contentId,
  fetchPolicy,
  skip
}) => {
  const {
    lesson
  } = useFullLessonChirp({
    lessonId,
    skip,
    fetchPolicy
  });
  if (!lesson) {
    return undefined;
  }
  return lesson.content.find(content => content.id === contentId);
};